import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { AuthLayoutRoutes } from 'src/app/services/navigation-services/auth-layout-routes.service';
import { CustomLayoutRoutes } from 'src/app/services/navigation-services/custom-layout-routes.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.scss']
})
export class PasswordUpdateComponent implements OnInit {

  alert: string;
  isError: boolean;
  isExternalToken: boolean;
  resetForm = new FormGroup(
    {
      password: new FormControl('', [Validators.required, 
      ]),
      oldpassword: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required, this.matchValidator('password', 'confirmPassword')]),
    },
    [this.matchValidator('confirmPassword', 'password')]
  );

  constructor(private auth: AuthService, private errorEvent: EventService, private authroute: AuthLayoutRoutes,private snackBar: SnackbarService, ) {
  }

  ngOnInit(): void {
    if (!this.auth.user?.userName) {
      this.authroute.navigateToLogin();
    }
    this.errorEvent.httpErrorMessageEvent.subscribe(message => {
      if (message) {
        let i = this.errorEvent.getErrID();
        if (message.includes(i)) {
          message = message.replace(i, '');
        }
      }
      this.alert = message;
      this.isError = true;
    });
  }
  async updatePassword() {
    let data = {
      password: this.resetForm.get('password')?.value,
      oldPassword: this.resetForm.get('oldpassword')?.value,
      username: this.auth.user?.userName
    };
  try {
    await this.auth.updatePassword(data).then((res: any) => {
      this.snackBar.success('Password updated successfully');
      this.authroute.navigateToLogin();
    });
  } catch (error) {
    this.snackBar.error('Error updating password');
    console.error('Error:' + error);
  }
  }

  get passwordMatchError() {
    return (
      this.resetForm.getError('mismatch') &&
      this.resetForm.get('password')?.touched
    );
  }
  matchValidator(source: string, target: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const sourceCtrl = control.get(source);
      const targetCtrl = control.get(target);
      return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value ? { mismatch: true } : null;
    };
  }
}
